var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('kst-output',{attrs:{"print-mode":"","field":"ClientID","data":_vm.details,"catalog":_vm.Catalog}}),_c('kst-output',{attrs:{"print-mode":"","field":"Destination","data":_vm.details,"catalog":_vm.Catalog}}),_c('kst-output',{attrs:{"print-mode":"","field":"ShipmentFee","data":_vm.details,"catalog":_vm.Catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }